<div class="flex-row" style="height: 100%">
  <div class="column-container">
    <div class="flex-row">
      <kpi4me-select-element
        class="selection-action"
        [formControlElement]="form.controls.ambulanceStation"
        [data]="ambulanceStationData()"
      />

      <app-cart-filter-selection
        class="selection-action"
        [formControlElement]="form.controls.cart"
      />
    </div>

    <div class="flex-row">
      <kpi4me-checkbox-element
        class="selection-action"
        [displayAs]="'toggle'"
        [label]="'Fahrten mit Auffälligkeiten'"
        [formControlElement]="form.controls.cartsWithConspicuities"
      />

      <button
        class="selection-action-button"
        mat-button
        mat-raised-button
        color="accent"
        [disabled]="cartFilterSelectionRef().loading()"
        (click)="createNewCart()"
      >
        Neuen Einsatz erstellen
      </button>
    </div>

    <div class="flex-row">
      <button
        class="selection-action-button"
        mat-button
        mat-raised-button
        color="primary"
        [disabled]="cartFilterSelectionRef().loading()"
        (click)="navigateCart('previous')"
      >
        Vorherige Fahrt
      </button>

      <button
        class="selection-action-button"
        mat-button
        mat-raised-button
        color="primary"
        [disabled]="cartFilterSelectionRef().loading()"
        (click)="navigateCart('next')"
      >
        Nächste Fahrt
      </button>
    </div>

    <div class="conspicuity-container">
      @if (conspicuityMessage().length > 0) {
        <mat-icon color='warn' [svgIcon]="EsvgFiles.warning"/>
      } @else {
        <mat-icon color='accent' [svgIcon]="EsvgFiles.correct"/>
      }
      <br>
      {{ conspicuityMessage() || "Alles in Ordnung!" }}
    </div>

    @if (selectedCart()) {
      <app-not-billable-form
        style="display: none"
        [selectedElement]="selectedCart().obj"
        [displayHeaders]="false"
        [standardForm]="false"
        [(minScore)]="minScore"
        [(numberOfWantedClients)]="numberOfWantedClients"
        [(availableClients)]="availableClients"
        [(rowData)]="rowData"
        [(clientsMessage)]="clientsMessage"
        [(displayOnlyFlags)]="displayOnlyFlags"
        [(clients)]="clients"
      />

      @if (notBillableFormRef().isChanged()) {
        @if (rowData()) {
          <ag-grid-angular
            (resized)="missionDataCollectionGridApi?.sizeColumnsToFit()"
            (gridReady)="missionDataCollectionGridApi = $event.api"
            [style.height.px]="30 * 8"
            [gridOptions]="gridOptions"
            [rowData]="rowData()"
            [columnDefs]="colDefs"
            class="ag-theme-alpine hide-header"
          />
        } @else {
          <div class="centered" style="height: 50px">
            <mat-progress-bar mode="indeterminate"/>
          </div>
        }
      } @else {
        <div class="centered" style="height: 50px">
          <mat-progress-bar mode="indeterminate"/>
        </div>
      }

      <kpi4me-crew-detail [showImports]="false" class="form"/>
    }
  </div>

  <mat-divider/>

  <div class="column-container" style="display: flex; flex-direction: column">
    @if (selectedCart()) {
      <ng-container>
        <kpi4me-client-detail
          [showImports]="false"
          class="form"
          style="height: min-content"
        />
      </ng-container>

      @if (selectedCart() && clients()?.length) {
        <div class="mat-h3" style="margin-top: 1.5rem">
          Patientenvergleich
          <div class="mat-caption">
            Es gibt Patienten mit ähnlichen Daten
          </div>
        </div>

        <app-clients-comparator-table
          style="flex: 1"
          [clients]="clients()"
          (takeData)="onTakeDataOfClient($event)"
          (getAnotherClient)="onGetAnotherClient($event)"
          (onSeparateClientReference)="separateClientReference()"
          (initialized)="shrinkClientComparatorColumns()"
        />
      } @else {
        <div class="centered" style="height: 50px">
          <mat-progress-bar mode="indeterminate"/>
        </div>
      }
    }
  </div>

  <mat-divider/>

  <div class="column-container">
    @if (selectedCart()) {
      <h5>Transport</h5>
      <div>
        <kpi4me-transport-detail [showImports]="false" class="form"/>
      </div>
    }
  </div>
</div>
